import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from 'layouts/AuthLayout';
import HomeLayout from 'layouts/HomeLayout';
import FormLayout from 'layouts/FormLayout';
import NoConnectionPage from 'pages/NoConnection';


const authRoutesConfig = {
  '/auth/login': 'Login',
  '/auth/forgot-password': 'ForgotPassword',
  '/auth/reset-password': 'ResetPassword',
  '/auth/send-verify-email': 'VerifyEmailSend',
  '/auth/verification': 'EmailVerification',
};

const authRoutes = Object.entries(authRoutesConfig).map(([path, page]) => ({
  path,
  exact: true,
  component: lazy(() => import(`pages/${page}`)),
}));

authRoutes.push({
  component: () => <Redirect to="/auth/login" />,
});

const homeRoutesConfig = {
  '/dashboard': 'Dashboard',
  '/users/create': 'User',
  '/user': 'User',
  '/internal/users': 'InternalUsers',
  '/internal/teams': 'Teams',
  '/internal/admins': 'Admins',
  '/external/companies': 'Clients',
  '/external/users-international': 'Users_International',
  '/users-international/create': 'Users_International/UserDetails',
  '/external/users': 'Users',
  '/external/users_dashboard': 'Users/Dashboard',
  '/external/notifications': 'UserNotifications',
  '/external/historique': 'ExternalUsersHistorique',
  '/external/clients-exclusion': 'ClientsExclusion',
  '/external/clients-international': 'ClientsInternational',
  '/external/clients-onedata': 'ClientsOneData',
  '/external/monitoring': 'ClientsMonitoring',
  '/external/users_onedata': 'UsersOneData',
  '/external/users_monitoring': 'UsersMonitoring',
  '/teams/create': 'Team',
  '/contacts': 'Leads',
  '/clients/create': 'Client',
  '/client': 'Client',
  '/client-onedata': 'ClientOneData',
  '/forms-list': 'Leads/sites',
  '/catalogues': 'Catalogue',
  '/catalogues/:type': 'Catalogue',
  '/recycles': 'Catalogue/recycles',
  '/associatedproducts': 'Catalogue/associatedProducts',
  '/conditions-ventes': 'Catalogue/conditionsVentes',
  '/catalogues/catalogue/create': 'Catalogue/Details',
  '/catalogues/catalogue/details': 'Catalogue/Details',
  '/data': 'Products',
  '/data/products': 'Products',
  '/data/products/create': 'Products/Details',
  '/data/product': 'Products/Details',
  '/data/sessions': 'Sessions',
  '/data/locationsforum': 'LocationsForum',
  '/locations': 'Locations',
  '/data/inspection': 'Caracteristiques',
  '/data/inspection/caracteristiques': 'Caracteristiques',
  '/data/compteSel': 'CompteSel',
  '/data/offre': 'Offre',
  '/data/facture': 'Facture',
  '/data/inspection/equipement': 'Equipement',
  '/data/inspection/interventionSel': 'InterventionSel',
  '/data/inspection/codeproducts': 'CodeProduct',
  '/data/training': 'Training',
  '/data/agencies': 'Agency/References',
  '/data/agencies/data': 'Agency/Data',

  '/logs': 'Logs',

  //XSELL
  '/xsell': 'Xsell/Users',
  '/xsell/users': 'Xsell/Users',
  '/xsell/submissions': 'Xsell/Submissions',
  '/api_doc': '',
  // '/maintenance': 'Maintenance',
  '/profile': 'ProfileSettings',
};

const homeRoutes = Object.entries(homeRoutesConfig).map(([path, page]) => ({
  path,
  exact: true,
  component: page ? lazy(() => import(`pages/${page}`)) : null,
}));

homeRoutes.push({
  path: '/internal',
  exact: true,
  component: () => <Redirect to="/internal/users" />,
});
homeRoutes.push({
  path: '/external',
  exact: true,
  component: () => <Redirect to="/external/companies" />,
});
homeRoutes.push({
  component: () => <Redirect to="/users" />,
});

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/external/companies" />,
  },
  {
    path: '/no-connection',
    exact: true,
    component: NoConnectionPage,
  },
  {
    path: '/form',
    component: FormLayout,
    routes: [
      {
        path: '/form/:id',
        exact: true,
        component: lazy(() => import('pages/SiteForm')),
      }
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: authRoutes,
  },
  {
    path: '*',
    component: HomeLayout,
    routes: homeRoutes
  },
];

export default routes;
